// extracted by mini-css-extract-plugin
export const sectionSpacing = "mercado-laboral-module--section-spacing--3ENog";
export const rowSpacing = "mercado-laboral-module--row-spacing--zMxP0";
export const rowSpacingSml = "mercado-laboral-module--row-spacing-sml--2I6l3";
export const intro = "mercado-laboral-module--intro--1uRpS";
export const merLabRow = "mercado-laboral-module--merLabRow--IPkgj";
export const posts = "mercado-laboral-module--posts--Bdiut";